module.exports = __webpack_public_path__ + "img/nature40.d2bb651c.jpg";